import {getUrlParamsDecoded} from "System/utilities/strings.js";
import langstore from 'System/i18n/translator.js';

// generic error


// execute login
const ssoGemoLogin = async function(userData){

  let url = this.config.paths.apiURL + "profilo/ssologin/gemo/login";

  let response = await this.dataLayer({
    url: url,
    cacheAge: 0,
    params: userData
  });

  return response;
}


// validate ID token
const ssoGemoValidateId = async function(params){

  let url = this.config.paths.apiURL + "profilo/ssologin/gemo/users";

  let response = await this.dataLayer({
    url: url,
    cacheAge: 0,
    params: {
      id: params.id,
      cliente: parseInt(params.cliente),
      userid: params.userid
    },
  });

  return response;
}


const ssoGemoActions = async function(){

  let loadingKey = "ssoGemoActions";
  let {op,id,userid,cliente} = getUrlParamsDecoded();

  if(!op || !id || !userid || !cliente){
    this.routeChange("login");
    this.notificationAdd(langstore.t("sso_gemo_error_params","Formato URL errato"),loadingKey);
    return;
  }

  this.loadingAdd(loadingKey);

  // case: login
  if(op == "LOGIN"){

    try {

      let isValid = await this.ssoGemoValidateId({op,id,userid,cliente});

      if(!isValid || isValid.status !== "OK" || !isValid.data || !isValid.data.users || isValid.data.users.length == 0){
        this.notificationAdd(langstore.t("sso_gemo_error","Si è verificato un errore"),loadingKey);
        this.routeChange("login");
        this.loadingAdd(loadingKey);
        return;
      }

      let isUser = await this.ssoGemoLogin(isValid.data.users[0]);

      if(!isUser || isUser.status !== "OK" || !isUser.data || !isValid.data.auth !== true){
        this.notificationAdd(langstore.t("sso_gemo_error_login","Autenticazione non riuscita"),loadingKey);
        this.routeChange("login");
        this.loadingAdd(loadingKey);
        return;
      }

      this.routeChange(this.config.routes.index);
      this.userAuth(isUser, loadingKey);

    }
    catch (e){
        this.notificationAdd(langstore.t("sso_gemo_error","Si è verificato un errore"),"ssoGemoActions");
        this.routeChange("login");
        this.loadingAdd("ssoGemoActions");
        return;
    }

  }


}



export {
  ssoGemoActions,
  ssoGemoValidateId,
  ssoGemoLogin
}